import React from 'react';
import Icon from 'components/AppIcon';

const ProgressIndicator = ({ currentStep, completedSteps, onStepClick }) => {
  const steps = [
    { id: 1, title: 'Dates & Rooms', icon: 'Calendar' },
    { id: 2, title: 'Guest Details', icon: 'Users' },
    { id: 3, title: 'Payment', icon: 'CreditCard' },
    { id: 4, title: 'Confirmation', icon: 'CheckCircle' }
  ];

  const getStepStatus = (stepId) => {
    if (completedSteps?.includes(stepId)) return 'completed';
    if (stepId === currentStep) return 'current';
    return 'pending';
  };

  const getStepClasses = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-success text-success-foreground border-success';
      case 'current':
        return 'bg-primary text-primary-foreground border-primary';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between">
        {steps?.map((step, index) => (
          <React.Fragment key={step?.id}>
            <div className="flex flex-col items-center">
              <button
                onClick={() => completedSteps?.includes(step?.id) && onStepClick(step?.id)}
                disabled={!completedSteps?.includes(step?.id) && step?.id !== currentStep}
                className={`w-12 h-12 rounded-full border-2 flex items-center justify-center transition-organic ${
                  getStepClasses(getStepStatus(step?.id))
                } ${
                  completedSteps?.includes(step?.id) ? 'cursor-pointer hover:scale-105' : 'cursor-default'
                }`}
              >
                {getStepStatus(step?.id) === 'completed' ? (
                  <Icon name="Check" size={20} />
                ) : (
                  <Icon name={step?.icon} size={20} />
                )}
              </button>
              <span className="text-sm font-medium text-card-foreground mt-2 text-center">
                {step?.title}
              </span>
            </div>
            
            {index < steps?.length - 1 && (
              <div className="flex-1 mx-4">
                <div className={`h-0.5 transition-organic ${
                  completedSteps?.includes(step?.id + 1) || currentStep > step?.id
                    ? 'bg-success' :'bg-border'
                }`} />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;